import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import Header from "./header";
import Footer from "./footer";
import { studentdashboardcount, studentdetail, studentview, updateprofilephoto } from "../service/dashboard";
import moment from "moment";
import { toast } from "react-toastify";
import { Card, Col, Row } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const StudentProfile = () => {
    const { id } = useParams();
    const [student, setStudent] = useState(null);
    const [hdetail, setHDetail] = useState('');
    const [adetail, setADetail] = useState([]);
    const [attdet, setAttdet] = useState([]);
    const [periods, setPeriod] = useState([]);
    const [sfees, setSFees] = useState([]);
    const [edetail, setEDetail] = useState([]);
    const [activeTab, setActiveTab] = useState("profile");
    const [fdate, setFDate] = useState("");
    const [tdate, setTDate] = useState("");
    const [hwlist, setHWList] = useState([]);
    const [hwpath, setHPath] = useState("");
    const [tpath, setTPath] = useState("");
    const [flist, setFList] = useState([]);
    const [fhlist, setFHList] = useState([]);
    const [page, setPage] = useState(1);

    const [photoFile, setPhotoFile] = useState(null);
    const [preview, setPreview] = useState(null);
    const [uploading, setUploading] = useState(false);


    const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const [urllink, setUrllink] = useState("");
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname.split("/")[1];
        setUrllink(path);
        setFDate(moment(new Date()).format("YYYY-MM-DD"));
        setTDate(moment(new Date()).format("YYYY-MM-DD"));
        if (path == "feessummary") {
            setActiveTab("fees");
            const temp = new FormData();
            temp.append("user_id", localStorage.getItem("UID"));
            studentdashboardcount(temp).then((res) => {
                if (res.status === true) {
                    studentdetail(res.data.students.id, moment(new Date()).format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD")).then((res1) => {
                        if (res1.status === true) {
                            setStudent(res1.data.details);
                            setSFees(res1.data.feesamount);
                            setTPath(res1.data.tpath);
                            if (res1.data.feeslist.length > 0) {
                                const cdata = res1.data.feeslist.map((item) => {
                                    return {
                                        ...item,
                                        paid_date: item.paid_date ? moment(item.paid_date).format("DD-MM-YYYY") : null,
                                    }
                                });
                                setFList(cdata);
                            }
                            if (res1.data.feeshistory.length > 0) {
                                const cdata = res1.data.feeshistory.map((item) => {
                                    return {
                                        ...item,
                                        payment_date: moment(item.payment_date).format("DD-MM-YYYY"),
                                    }
                                });
                                setFHList(cdata);
                            }
                        }
                    });
                }
            });
        } else if (path == "student-profile") {
            setActiveTab("profile");
            studentdetail(id, moment(new Date()).format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD")).then((res1) => {
                if (res1.status === true) {
                    setStudent(res1.data.details);
                    setHDetail(res1.data.hostel);
                    setADetail(res1.data.attendance);
                    const adata = res1.data.attendance.filter((item) => item.attendance.length > 0);
                    setAttdet(adata);
                    setSFees(res1.data.feesamount);
                    setEDetail(res1.data.examdetails);
                    setHPath(res1.data.homepath);
                    setTPath(res1.data.tpath);
                    if (res1.data.feeslist.length > 0) {
                        const cdata = res1.data.feeslist.map((item) => {
                            return {
                                ...item,
                                paid_date: item.paid_date ? moment(item.paid_date).format("DD-MM-YYYY") : null,
                            }
                        });
                        setFList(cdata);
                    }
                    if (res1.data.feeshistory.length > 0) {
                        const cdata = res1.data.feeshistory.map((item) => {
                            return {
                                ...item,
                                payment_date: moment(item.payment_date).format("DD-MM-YYYY"),
                            }
                        });
                        setFHList(cdata);
                    }
                    if (res1.data.details !== null) {
                        const temp = new FormData();
                        temp.append("user_id", res1.data.details.user_id);
                        temp.append("year", res1.data.details.academicyear);
                        studentdashboardcount(temp).then((res) => {
                            if (res.status === true) {
                                const periodMap = {};

                                res.data.timetable.forEach(entry => {
                                    const key = `${entry.period}_${entry.from_time}`;

                                    if (!periodMap[key]) {
                                        periodMap[key] = {
                                            period: entry.period,
                                            slot_name: entry.slot_name,
                                            from_time: entry.from_time,
                                            to_time: entry.to_time,
                                            is_break: entry.is_break,
                                            schedule: {
                                                Monday: null,
                                                Tuesday: null,
                                                Wednesday: null,
                                                Thursday: null,
                                                Friday: null,
                                                Saturday: null,
                                            },
                                        };
                                    }

                                    periodMap[key].schedule[entry.day] = {
                                        subject_name: entry.subject_name,
                                        teacher_name: entry.teacher_name,
                                        teacher_photo: entry.teacher_photo,
                                    };
                                });

                                let arr = Object.values(periodMap).sort((a, b) => a.period - b.period);

                                setPeriod(arr);
                            }
                        })

                    }

                }
            });
        }

    }, [location]);

    function errorphoto(ev) {
        ev.target.src = require("../assets/images/placeholder.png");
        ev.target.onerror = null;
    }
    function errorhome(ev) {
        ev.target.src = require("../assets/images/photo.png");
        ev.target.onerror = null;
    }

    function handlePhotoSelect(ev) {
        const file = ev.target.files[0];
        if (!file) return;
        setPhotoFile(file);
        setPreview(URL.createObjectURL(file));
    }

    function handlePhotoSubmit() {
        if (!photoFile) {
            toast.error("Please select a photo");
            return;
        }
        setUploading(true);
        const temp = new FormData();
        temp.append("user_id", student.user_id);
        temp.append("role_id", "4");
        temp.append("photo", photoFile);
        updateprofilephoto(temp).then((res) => {
            setUploading(false);
            if (res && res.status === true) {
                toast.success(res.message);
                setStudent((prev) => ({
                    ...prev,
                    photo: res.data.photo,
                    ...(res.data.path ? { path: res.data.path } : {}),
                }));
                setPhotoFile(null);
                setPreview(null);
            } else {
                toast.error(res?.message || "Failed to update photo");
            }
        });
    }

    if (!student) {
        return <p className="text-center mt-5">Loading...</p>;
    }
    function listall(fdte, tdte) {
        setFDate(fdte);
        setTDate(tdte);
        setHWList([]);
        studentview(id, fdte, tdte).then((res) => {
            if (res.status === true) {
                if (res.data.homework.length == 0) {
                    setHWList(res.data.homework);
                }
            }
        })
    }
    const calculateGrandTotal = (details) => {
        return details.reduce((total, detail) => {
            const theoryMarks = parseInt(detail.exam_details_theory_mark) || 0;
            const practicalMarks = parseInt(detail.exam_details_pratical_mark) || 0;
            return total + theoryMarks + practicalMarks;
        }, 0);
    };

    // Function to calculate Total Obtained Marks
    const calculateTotalObtainedMarks = (details) => {
        return details.reduce((total, detail) => {
            const theoryMarks = parseInt(detail.theory_mark) || 0;
            const practicalMarks = parseInt(detail.practical_mark) || 0;
            return total + theoryMarks + practicalMarks;
        }, 0);
    };

    // Function to calculate Percentage
    const calculatePercentage = (details) => {
        const totalObtainedMarks = calculateTotalObtainedMarks(details);
        const grandTotal = calculateGrandTotal(details);
        return grandTotal > 0 ? ((totalObtainedMarks / grandTotal) * 100).toFixed(2) : 0;
    };

    const prepareChartData = (data) => {
        const feeTypes = data.year.map(fee => fee.type);
        const totalAmounts = data.year.map(fee => parseFloat(fee.total_amount));
        const paidAmounts = data.year.map(fee => parseFloat(fee.paid_amount));
        const pendingAmounts = data.year.map(fee => parseFloat(fee.pending_amount));

        const totalFeeAmount = totalAmounts.reduce((acc, amount) => acc + amount, 0);
        const totalPaidAmount = paidAmounts.reduce((acc, amount) => acc + amount, 0);
        const totalPendingAmount = pendingAmounts.reduce((acc, amount) => acc + amount, 0);
        feeTypes.push("Total Fees");
        totalAmounts.push(totalFeeAmount);
        paidAmounts.push(totalPaidAmount);
        pendingAmounts.push(totalPendingAmount);


        return {
            labels: feeTypes,
            datasets: [
                {
                    label: 'Total Amount',
                    data: totalAmounts,
                    backgroundColor: 'rgba(75, 192, 192, 0.5)',
                    borderColor: 'rgba(75, 192, 192, 1)',
                    borderWidth: 1
                },
                {
                    label: 'Paid Amount',
                    data: paidAmounts,
                    backgroundColor: 'rgba(54, 162, 235, 0.5)',
                    borderColor: 'rgba(54, 162, 235, 1)',
                    borderWidth: 1
                },
                {
                    label: 'Pending Amount',
                    data: pendingAmounts,
                    backgroundColor: 'rgba(255, 99, 132, 0.5)',
                    borderColor: 'rgba(255, 99, 132, 1)',
                    borderWidth: 1
                }
            ]
        };
    };
    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            title: {
                display: true,
                // text: 'Fee Breakdown by Type',
                font: {
                    size: 20
                }
            },
            legend: {
                position: 'top',
            },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        return `${context.dataset.label}: ₹${context.raw.toFixed(2)}`;
                    }
                }
            }
        },
        scales: {
            x: {
                beginAtZero: true,
            },
            y: {
                beginAtZero: true,
            }
        }
    };

    // Pagination state
    const perPage = 5;

    const paginatedFees = flist.slice((page - 1) * perPage, page * perPage);
    const totalPages = Math.ceil(flist.length / perPage);
    return (
        <div id="mainpage">
            <div className="maincontent">
                <Header />
                <div className="moreheading">
                    <Row className="row-sm">

                        <Col xs={6} className="text-left align-self-end">
                            <h4 className="morehead-text">{urllink === "feessummary" ? "Fee Summary" : "Student Profile"}</h4>
                        </Col>

                        <Col xs={6} className="text-right align-self-end">
                            <Link to={urllink === "feessummary" ?  "/dashboard" : "/studentlist"} className="btn-outline-success red-btn btn-sm">
                                <i className="fa-solid fa-hand-point-left"></i> Go Back
                            </Link>
                        </Col>

                    </Row>
                </div>
                {/* Student Card */}
                <div className="container mt-3">
                    {urllink !== "feessummary" &&
                    <div className="card text-center p-3 shadow-sm">
                        <div style={{ position: "relative", display: "inline-block", margin: "0 auto" }}>
                            {preview ? (
                                <img
                                    src={preview}
                                    alt="student-preview"
                                    className="rounded-circle mx-auto"
                                    style={{ width: "90px", height: "90px", objectFit: "cover" }}
                                />
                            ) : (
                                <img
                                    src={student.path + student.photo}
                                    onError={errorphoto}
                                    alt="student"
                                    className="rounded-circle mx-auto"
                                    style={{ width: "90px", height: "90px", objectFit: "cover" }}
                                />
                            )}

                            {localStorage.getItem("Role") == 5 && urllink === "student-profile" && !photoFile && (
                                <label
                                    htmlFor="studentPhotoInput"
                                    title="Edit Photo"
                                    style={{
                                        position: "absolute",
                                        bottom: "0px",
                                        right: "0px",
                                        width: "28px",
                                        height: "28px",
                                        borderRadius: "50%",
                                        background: "#198754",
                                        color: "#fff",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cursor: "pointer",
                                        boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
                                    }}
                                >
                                    <i className="fa-solid fa-camera"></i>
                                </label>
                            )}
                            <input
                                id="studentPhotoInput"
                                type="file"
                                accept="image/*"
                                style={{ display: "none" }}
                                onChange={handlePhotoSelect}
                            />

                            {photoFile && (
                                <div
                                    style={{
                                        position: "absolute",
                                        bottom: "0px",
                                        right: "0px",
                                        display: "flex",
                                        gap: "6px",
                                    }}
                                >
                                    <button
                                        type="button"
                                        title="Submit"
                                        onClick={handlePhotoSubmit}
                                        disabled={uploading}
                                        style={{
                                            width: "28px",
                                            height: "28px",
                                            borderRadius: "50%",
                                            background: "#198754",
                                            color: "#fff",
                                            border: "none",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            cursor: "pointer",
                                            boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
                                        }}
                                    >
                                        <i className={uploading ? "fa-solid fa-spinner fa-spin" : "fa-solid fa-check"}></i>
                                    </button>
                                    <button
                                        type="button"
                                        title="Cancel"
                                        onClick={() => { setPhotoFile(null); setPreview(null); }}
                                        disabled={uploading}
                                        style={{
                                            width: "28px",
                                            height: "28px",
                                            borderRadius: "50%",
                                            background: "#dc3545",
                                            color: "#fff",
                                            border: "none",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            cursor: "pointer",
                                            boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
                                        }}
                                    >
                                        <i className="fa-solid fa-xmark"></i>
                                    </button>
                                </div>
                            )}
                        </div>

                        <h5 className="mt-2">{student.student_name}</h5>
                        <p className="text-muted">
                            {student.class_name} - {student.section_name}
                        </p>
                        <p className="text-muted">
                            {student.gender}
                        </p>
                    </div>
}
                    {urllink === "feessummary" ? (
                        <div className="tabs mt-3">
                            {["fees", "fee history"].map((tab) => (
                                <button
                                    key={tab}
                                    className={`tab-btn ${activeTab === tab ? "active" : ""}`}
                                    onClick={() => setActiveTab(tab)}
                                >
                                    {tab.toUpperCase()}
                                </button>
                            ))}
                        </div>
                    ) : (
                        <div className="tabs mt-3">
                            {["profile", "parents detail", "attendance", "timetable", "homework", "exam", "fees", "fee history"].map((tab) => (
                                <button
                                    key={tab}
                                    className={`tab-btn ${activeTab === tab ? "active" : ""}`}
                                    onClick={() => setActiveTab(tab)}
                                >
                                    {tab.toUpperCase()}
                                </button>
                            ))}
                        </div>
                    )
                    }



                    {activeTab === "profile" && (
                        <>
                            {/* PERSONAL DETAIL */}
                            <div className="card mt-3 shadow-sm">
                                <div className="card-header custom-header">
                                    PERSONAL DETAIL
                                </div>
                                <div className="card-body">
                                    <div className="detail-grid">
                                        <div><b>Name</b><span>{student.student_name}</span></div>
                                        <div><b>DOB</b><span>{student ? moment(student.date_of_birth).format("DD-MM-YYYY") : ""}</span></div>
                                        <div><b>Blood Group</b><span>{student.blood_name || "-"}</span></div>
                                        <div><b>Email</b><span>{student.primary_email || "-"}</span></div>
                                        <div><b>Phone</b><span>{student.phone}</span></div>
                                        <div><b>Aadhar No</b><span>{student.aadhar_no || "-"}</span></div>
                                        <div><b>EMIS No</b><span>{student.emis_no || "-"}</span></div>


                                        <div><b>Religion</b><span>{student.rel_name || "-"}</span></div>
                                        <div><b>Caste</b><span>{student.subcaste_name || "-"}</span></div>
                                        <div><b>Sub Caste</b><span>{student.sub_caste || "-"}</span></div>
                                        <div><b>Mother Tongue</b><span>{student.mother_tongue || "-"}</span></div>
                                        <div><b>Address</b><span>{student.address1 || "-"}</span></div>
                                        <div><b>Pin Code</b><span>{student.pincode || "-"}</span></div>
                                    </div>
                                </div>
                            </div>

                            {/* ACADEMY DETAIL */}
                            <div className="card mt-3 shadow-sm">
                                <div className="card-header custom-header">
                                    ACADEMY DETAIL
                                </div>

                                <div className="card-body">
                                    <div className="detail-grid">
                                        <div><b>Unique No</b><span>{student.username}</span></div>
                                        <div><b>Roll No</b><span>{student.roll_number}</span></div>
                                        <div><b>Admission No</b><span>{student.admission_number}</span></div>
                                        <div><b>Academic Year</b><span>{student.aca_year}</span></div>
                                        <div><b>Admission Date</b><span> {student ? moment(student.admission_date).format("DD-MM-YYYY") : ""}</span></div>

                                        <div><b>Pre Institute</b><span>{student.institute_name || "-"}</span></div>
                                        <div><b>Pre Medium</b><span>{student.medium_name || "-"}</span></div>
                                        <div><b>Pre TC No</b><span>{student.tc_number || "-"}</span></div>
                                    </div>
                                </div>
                            </div>
                            {student.resident_type == '2' &&
                                <div className="card mt-3 shadow-sm">
                                    <div className="card-header custom-header">
                                        HOSTEL DETAIL
                                    </div>

                                    <div className="card-body">
                                        <div className="detail-grid">
                                            <div><b>Hostel</b><span>{hdetail.hostel_name}</span></div>
                                            <div><b>Room No</b><span>{hdetail.room_no}</span></div>
                                            <div><b>Warden</b><span>{hdetail.worker_name}</span></div>
                                            <div><b>Admission Date</b><span>{hdetail ? moment(hdetail.hostel_date).format('DD-MM-YYYY') : ''}</span></div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {student.resident_type == '3' &&
                                <div className="card mt-3 shadow-sm">
                                    <div className="card-header custom-header">
                                        TRANSPORT DETAIL
                                    </div>

                                    <div className="card-body">
                                        <div className="detail-grid">
                                            <div><b>Vehicle No</b><span>{student.vehicle_no}</span></div>
                                            <div><b>Driver</b><span>{student.worker_name}</span></div>
                                            <div><b>Route</b><span>{student.vehroute_name}</span></div>
                                            <div><b>Mobile No</b><span>{student.worker_phone}</span></div>
                                        </div>
                                    </div>
                                </div>
                            }

                        </>
                    )}

                    {/* PARENTS */}
                    {activeTab === "parents detail" && (
                        <div className="card mt-3 shadow-sm">
                            <div className="card-header custom-header">
                                PARENTS DETAIL
                            </div>

                            <div className="card-body">
                                <div className="detail-grid">
                                    <div><b>Father Name</b><span>{student.father_name || "-"}</span></div>
                                    <div><b>Mother Name</b><span>{student.mother_name || "-"}</span></div>
                                    <div><b>Guardian</b><span>{student.guardian_name || "-"}</span></div>
                                    <div><b>Email</b><span>{student.parent_email || "-"}</span></div>
                                    <div><b>Phone</b><span>{student.parent_phone || "-"}</span></div>
                                    <div><b>Qualification</b><span>{student.qualification || "-"}</span></div>
                                    <div><b>Occupation</b><span>{student.occupation || "-"}</span></div>
                                    <div><b>Annual Income</b><span>₹ {student ? student.annual_income : ''} /-</span></div>
                                    <div><b>Permanent Address</b><span>{student.permanent_address || "-"}</span></div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* ATTENDANCE */}
                    {activeTab === "attendance" && (
                        <div className="card mt-3 p-3 shadow-sm">
                            {adetail && adetail.length > 0 &&
                                adetail.map((item, index) => (
                                    <div key={index} className="row row-cards mt-1">
                                        {item.attendance.length > 0 &&
                                            <>
                                                <h5>{item.year}</h5>
                                                <div className="row">
                                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">

                                                        <div className="card bg-custom">
                                                            <div className="card-body text-center feature">
                                                                <p className="card-text mt-2">
                                                                    <strong>Total Days</strong>
                                                                </p>
                                                                <p className="h3 text-center text-info">{item.total_days}</p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                                        <div className="card bg-custom">
                                                            <div className="card-body text-center feature">
                                                                <p className="card-text mt-2">
                                                                    <strong>Total Present</strong>
                                                                </p>
                                                                <p className="h3 text-center text-success">{item.total_present_days}</p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                                        <div className="card bg-custom">
                                                            <div className="card-body text-center feature">
                                                                <p className="card-text mt-2">
                                                                    <strong>Total Absent</strong>
                                                                </p>
                                                                <p className="h3 text-center text-danger">{item.absent_days}</p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                                        <div className="card bg-custom">
                                                            <div className="card-body text-center feature">
                                                                <p className="card-text mt-2">
                                                                    <strong>Half day</strong>
                                                                </p>
                                                                <p className="h3 text-center text-warning">{item.half_day_present}</p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* <img
                                        alt="avatar"
                                      // src={require("../../../assets/images/Screenshot 2024-12-18 175942.png")}
                                      /> */}
                                                </div>
                                            </>
                                        }

                                    </div>
                                ))
                            }
                            {attdet && attdet.length == 0 &&
                                <div className="d-md-flex ms-auto mb-2">
                                    <label className="my-auto pt-2 exam-title"><strong>No Attendance Found</strong></label>
                                </div>
                            }
                        </div>
                    )}
                    {/* TIMETABLE */}
                    {activeTab === "timetable" && (
                        <div className="card mt-3 p-3 shadow-sm">
                            {/* MOBILE VIEW */}
                            <div className="mobile-timetable">
                                {periods.length === 0 && (
                                    <p className="text-center">No timetable found</p>
                                )}

                                {periods.map((period, index) => (
                                    <div key={index} className="tt-card">

                                        {/* Period Header */}
                                        <div className="tt-header">
                                            <div>
                                                <strong>{period.slot_name}</strong>
                                                <div className="tt-time">
                                                    {period.from_time} - {period.to_time}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Break */}
                                        {period.is_break === "Yes" ? (
                                            <div className="tt-break">{period.slot_name}</div>
                                        ) : (
                                            <div className="tt-body">
                                                {days.map((day, i) => (
                                                    <div key={i} className="tt-row">
                                                        <span className="day">{day}</span>

                                                        {period.schedule[day] ? (
                                                            <div className="subject">
                                                                <div className="sub-name">
                                                                    {period.schedule[day].subject_name}
                                                                </div>
                                                                <div className="teacher">
                                                                    {period.schedule[day].teacher_name}
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <span className="empty">-</span>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    {/* HOMEWORK */}
                    {activeTab === "homework" && (
                        <div className="card mt-3 p-3 shadow-sm">
                            <Row className=" row-sm">
                                <div className="col-xl-4 col-sm-6">
                                    <div className="mb-3">
                                        <label className="form-label">From Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={fdate}
                                            onChange={(e) => listall(e.target.value, tdate)}
                                        />
                                    </div>
                                </div>
                                <div className="col-xl-4 col-sm-6">
                                    <div className="mb-3">
                                        <label className="form-label">To Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={tdate}
                                            onChange={(e) => listall(fdate, e.target.value)}
                                            min={fdate}
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    {hwlist.map((item, i) => (
                                        <Card className=" mg-b-20 border" key={i}>
                                            <div className="p-4 card-headerr">
                                                <div className="media">
                                                    <div className="media-user me-2">
                                                        <div className="main-img-user avatar-md">
                                                            {item.teacher_photo !== null && (
                                                                <img
                                                                    src={
                                                                        tpath +
                                                                        item.teacher_photo
                                                                    }
                                                                    alt="Student"
                                                                    onError={errorphoto}
                                                                />
                                                            )}
                                                            {item.teacher_photo === null && (
                                                                <img
                                                                    src={require("../assets/images/placeholder.png")}
                                                                    alt="Student"
                                                                />
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="media-body">
                                                        <h6 className="mb-0 mg-t-2 ms-2">
                                                            {item.teacher_name}
                                                            <span className="text-muted ms-2">
                                                                {moment(item.created_at).format("MMM DD YYYY")}
                                                            </span>
                                                        </h6>
                                                        <span className="text-primary ms-2">
                                                            {item.subject_name}
                                                        </span>
                                                        <b className="text-danger ms-5">
                                                            Due Date: {moment(item.due_date).format("DD-MM-YYYY")}
                                                        </b>
                                                    </div>
                                                </div>
                                            </div>
                                            <Card.Body>
                                                {/* <h3>All of you Read thgis file</h3> */}
                                                <p className="mg-t-0">{item.description}</p>
                                                <Row className=" row-sm">
                                                    <div className="col">
                                                        {item &&
                                                            item.work_file &&
                                                            (item.work_file.split(".").pop() === "pdf" ? (
                                                                <a
                                                                    href={
                                                                        hwpath +
                                                                        item.academy_code +
                                                                        "/homework/" +
                                                                        item.work_file
                                                                    }
                                                                    target="_blank"
                                                                >
                                                                    <img
                                                                        src={require("../assets/images/pdf.png")}
                                                                        alt="PDF File"
                                                                        width={"100px"}
                                                                        height={"100px"}
                                                                    />
                                                                </a>
                                                            ) : (
                                                                <a
                                                                    href={
                                                                        hwpath +
                                                                        item.academy_code +
                                                                        "/homework/" +
                                                                        item.work_file
                                                                    }
                                                                    target="_blank"
                                                                >
                                                                    <img
                                                                        src={hwpath +
                                                                            item.academy_code +
                                                                            "/homework/" +
                                                                            item.work_file}
                                                                        alt="Other File"
                                                                        width={"100px"}
                                                                        height={"100px"}
                                                                        onerror={(ev) => errorhome(ev)}
                                                                    />
                                                                </a>
                                                            ))}
                                                    </div>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    ))}

                                    {hwlist.length === 0 && (
                                        <div className="d-md-flex ms-auto mb-2">
                                            <label className="my-auto pt-2 exam-title"><strong>No Homework Found</strong></label>
                                        </div>
                                    )}
                                </div>
                            </Row>
                        </div>
                    )}
                    {/* EXAM */}
                    {activeTab === "exam" && (
                        <div className="card mt-3 p-3 shadow-sm">
                            <div className="col-12">
                                <div className="exam-result-container">

                                    {/* ================= DESKTOP TABLE ================= */}
                                    <div className="table-scroll">
                                        {edetail.length > 0 && edetail.map((item, index) => (
                                            <div key={index}>

                                                <div className="mb-2">
                                                    <label className="exam-title">
                                                        <strong>{item.exam} ({item.year})</strong>
                                                    </label>
                                                </div>

                                                <table className="result-table">
                                                    <thead>
                                                        <tr>
                                                            <th>Subject</th>
                                                            <th>Theory</th>
                                                            <th>Practical</th>
                                                            <th>Min</th>
                                                            <th>Obtained</th>
                                                            <th>Result</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {item.details.map((detail, j) => {
                                                            const obtainedMarks =
                                                                (detail.theory_mark ?? 0) + (detail.practical_mark ?? 0);

                                                            return (
                                                                <tr key={j}>
                                                                    <td>
                                                                        {detail.subject_name}
                                                                        <br />
                                                                        {detail.exam_date &&
                                                                            "(" + moment(detail.exam_date).format("DD-MM-YYYY") + ")"}
                                                                        <br />
                                                                        {detail.exam_time && "(" + detail.exam_time + ")"}
                                                                    </td>

                                                                    <td>{detail.exam_details_theory_mark || "-"}</td>
                                                                    <td>{detail.exam_details_pratical_mark || "-"}</td>
                                                                    <td>{detail.pass_marks || "-"}</td>
                                                                    <td>{obtainedMarks}</td>

                                                                    <td>
                                                                        <span className={obtainedMarks >= detail.pass_marks ? "result-pass" : "result-fail"}>
                                                                            {obtainedMarks >= detail.pass_marks ? "Pass" : "Fail"}
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>

                                                {/* SUMMARY */}
                                                <div className="result-summary">
                                                    <p><strong>Percentage:</strong> {calculatePercentage(item.details)}%</p>
                                                    <p>
                                                        <strong>Result:</strong>{" "}
                                                        <span className={
                                                            item.details.some(d =>
                                                                ((d.theory_mark ?? 0) + (d.practical_mark ?? 0)) < d.pass_marks
                                                            ) ? "result-fail" : "result-pass"
                                                        }>
                                                            {item.details.some(d =>
                                                                ((d.theory_mark ?? 0) + (d.practical_mark ?? 0)) < d.pass_marks
                                                            ) ? "Fail" : "Pass"}
                                                        </span>
                                                    </p>
                                                    <p><strong>Grand Total:</strong> {calculateGrandTotal(item.details)}</p>
                                                    <p><strong>Total Marks:</strong> {calculateTotalObtainedMarks(item.details)}</p>
                                                </div>

                                                <hr />
                                            </div>
                                        ))}

                                        {edetail.length === 0 && (
                                            <div className="text-center">
                                                <strong>No Record Found</strong>
                                            </div>
                                        )}
                                    </div>

                                    {/* ================= MOBILE CARD VIEW ================= */}
                                    <div className="mobile-exam">

                                        {edetail.length > 0 && edetail.map((item, index) => (
                                            <div key={index} className="exam-card">

                                                <div className="exam-title">
                                                    {item.exam} ({item.year})
                                                </div>

                                                {item.details.map((detail, j) => {
                                                    const obtainedMarks =
                                                        (detail.theory_mark ?? 0) + (detail.practical_mark ?? 0);

                                                    return (
                                                        <div key={j} className="subject-card">

                                                            <div className="sub-head">
                                                                <strong>{detail.subject_name}</strong>
                                                                <span className={obtainedMarks >= detail.pass_marks ? "result-pass" : "result-fail"}>
                                                                    {obtainedMarks >= detail.pass_marks ? "Pass" : "Fail"}
                                                                </span>
                                                            </div>

                                                            <div className="sub-info">
                                                                <div>Theory: {detail.exam_details_theory_mark || "-"}</div>
                                                                <div>Practical: {detail.exam_details_pratical_mark || "-"}</div>
                                                                <div>Min: {detail.pass_marks || "-"}</div>
                                                                <div>Obtained: {obtainedMarks}</div>
                                                            </div>

                                                            {detail.exam_date && (
                                                                <div className="sub-date">
                                                                    {moment(detail.exam_date).format("DD-MM-YYYY")} | {detail.exam_time}
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })}

                                                <div className="exam-summary">
                                                    <p><strong>Percentage:</strong> {calculatePercentage(item.details)}%</p>
                                                    <p>
                                                        <strong>Result:</strong>{" "}
                                                        <span className={
                                                            item.details.some(d =>
                                                                ((d.theory_mark ?? 0) + (d.practical_mark ?? 0)) < d.pass_marks
                                                            ) ? "result-fail" : "result-pass"
                                                        }>
                                                            {item.details.some(d =>
                                                                ((d.theory_mark ?? 0) + (d.practical_mark ?? 0)) < d.pass_marks
                                                            ) ? "Fail" : "Pass"}
                                                        </span>
                                                    </p>
                                                    <p><strong>Grand Total:</strong> {calculateGrandTotal(item.details)}</p>
                                                    <p><strong>Total Marks:</strong> {calculateTotalObtainedMarks(item.details)}</p>
                                                </div>

                                            </div>
                                        ))}

                                        {edetail.length === 0 && (
                                            <div className="text-center">
                                                <strong>No Record Found</strong>
                                            </div>
                                        )}
                                    </div>

                                </div>
                            </div>
                        </div>
                    )}
                    {/* FEES */}
                    {activeTab === "fees" && (
                        <div className="card mt-3 p-3 shadow-sm">
                            {sfees.length > 0 && sfees.map((data, j) => (
                                <div key={j} className="fees-section">

                                    {/* Title */}
                                    <h5 className="fees-title">{data.academic}</h5>

                                    {/* Cards */}
                                    <div className="row g-2 mt-1">

                                        <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                                            <div className="card fee-card">
                                                <div className="card-body text-center">
                                                    <p className="fee-label">Total Fee</p>
                                                    <h5 className="text-info">₹ {data.total.total_amount}</h5>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                                            <div className="card fee-card">
                                                <div className="card-body text-center">
                                                    <p className="fee-label">Paid Fee</p>
                                                    <h5 className="text-success">₹ {data.total.paid_amount}</h5>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                                            <div className="card fee-card">
                                                <div className="card-body text-center">
                                                    <p className="fee-label">Pending Fee</p>
                                                    <h5 className="text-danger">₹ {data.total.pending_amount}</h5>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    {/* Chart */}
                                    <div className="chart-wrapper mt-3" style={{ width: "100%", height: "280px" }}>
                                        <Bar data={prepareChartData(data)} options={chartOptions} />
                                    </div>

                                </div>
                            ))}

                            {sfees.length === 0 && (
                                <div className="text-center mt-3">
                                    <strong>No Record Found</strong>
                                </div>
                            )}
                        </div>
                    )}

                    {/* FEES HISTORY*/}
                    {activeTab === "fee history" && (
                        <div className="card mt-3 p-3 shadow-sm">

                            <div className="desktop-view">

                                <h5>Fees List</h5>

                                <div className="table-responsive">
                                    <table className="table table-bordered table-striped">
                                        <thead className="table-primary">
                                            <tr>
                                                <th>Fee Type</th>
                                                <th>Date</th>
                                                <th>Academic Year</th>
                                                <th>Total</th>
                                                <th>Paid</th>
                                                <th>Discount</th>
                                                <th>Method</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {paginatedFees.map((item, i) => (
                                                <tr key={i}>
                                                    <td>{item.fees_type}</td>
                                                    <td>{item.paid_date}</td>
                                                    <td>{item.aca_year}</td>
                                                    <td>₹ {item.total_amount}</td>
                                                    <td className="text-success">₹ {item.paid_amount}</td>
                                                    <td>₹ {item.disc_amt}</td>
                                                    <td>{item.payment}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                {/* PAGINATION */}
                                <div className="pagination-box">
                                    <button disabled={page === 1} onClick={() => setPage(page - 1)}>Prev</button>
                                    <span>{page} / {totalPages || 1}</span>
                                    <button disabled={page === totalPages} onClick={() => setPage(page + 1)}>Next</button>
                                </div>

                                <hr />

                                {/* ===== FEES HISTORY ===== */}

                                <h5>Fees History List</h5>

                                <div className="table-responsive">
                                    <table className="table table-bordered table-striped">
                                        <thead className="table-primary">
                                            <tr>
                                                <th>Fee Type</th>
                                                <th>Date</th>
                                                <th>Academic Year</th>
                                                <th>Total</th>
                                                <th>Paid</th>
                                                <th>Discount</th>
                                                <th>Method</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {fhlist.map((item, i) => (
                                                <tr key={i}>
                                                    <td>{item.fees_type}</td>
                                                    <td>{item.payment_date}</td>
                                                    <td>{item.aca_year}</td>
                                                    <td>₹ {item.total_amount}</td>
                                                    <td className="text-success">₹ {item.payment_amount}</td>
                                                    <td>₹ {item.disc_amt}</td>
                                                    <td>{item.payment_method}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                            <div className="mobile-cards">

                                <h5>Fees List</h5>

                                {paginatedFees.map((item, i) => (
                                    <div key={i} className="fee-card-mobile">

                                        <div className="row">
                                            <div className="col-6"><strong>Fee Type:</strong></div>
                                            <div className="col-6 text-end">{item.fees_type}</div>

                                            <div className="col-6"><strong>Date:</strong></div>
                                            <div className="col-6 text-end">{item.paid_date}</div>

                                            <div className="col-6"><strong>Year:</strong></div>
                                            <div className="col-6 text-end">{item.aca_year}</div>

                                            <div className="col-6"><strong>Total:</strong></div>
                                            <div className="col-6 text-end">₹ {item.total_amount}</div>

                                            <div className="col-6"><strong>Paid:</strong></div>
                                            <div className="col-6 text-end text-success">₹ {item.paid_amount}</div>

                                            <div className="col-6"><strong>Discount:</strong></div>
                                            <div className="col-6 text-end">₹ {item.disc_amt}</div>

                                            <div className="col-6"><strong>Method:</strong></div>
                                            <div className="col-6 text-end">{item.payment}</div>
                                        </div>

                                    </div>
                                ))}

                                {/* PAGINATION */}
                                <div className="pagination-box">
                                    <button disabled={page === 1} onClick={() => setPage(page - 1)}>Prev</button>
                                    <span> {page} / {totalPages || 1} </span>
                                    <button disabled={page === totalPages} onClick={() => setPage(page + 1)}>Next</button>
                                </div>

                                <hr />

                                {/* ===== FEES HISTORY ===== */}

                                <h5>Fees History</h5>

                                {fhlist.map((item, i) => (
                                    <div key={i} className="fee-card-mobile">

                                        <div className="row">
                                            <div className="col-6"><strong>Fee Type:</strong></div>
                                            <div className="col-6 text-end">{item.fees_type}</div>

                                            <div className="col-6"><strong>Date:</strong></div>
                                            <div className="col-6 text-end">{item.payment_date}</div>

                                            <div className="col-6"><strong>Year:</strong></div>
                                            <div className="col-6 text-end">{item.aca_year}</div>

                                            <div className="col-6"><strong>Total:</strong></div>
                                            <div className="col-6 text-end">₹ {item.total_amount}</div>

                                            <div className="col-6"><strong>Paid:</strong></div>
                                            <div className="col-6 text-end text-success">₹ {item.payment_amount}</div>

                                            <div className="col-6"><strong>Discount:</strong></div>
                                            <div className="col-6 text-end">₹ {item.disc_amt}</div>

                                            <div className="col-6"><strong>Method:</strong></div>
                                            <div className="col-6 text-end">{item.payment_method}</div>
                                        </div>

                                    </div>
                                ))}
                                {fhlist.length === 0 && (
                                    <div className="text-center mt-3">
                                        <strong>No Record Found</strong>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                </div>
            </div>

            <Footer />
        </div>
    );
};

export default StudentProfile;